import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const childListSelector = createSelector(
  (state: RootState) => state.child.childList,
  (childList) => childList,
);

export const selectedChildSelector = createSelector(
  [
    (state: RootState) => state.child.childId,
    (state: RootState) => state.child.childList,
  ],
  (childId, childList) => childList.find((v) => v.childId === childId),
);
